if (!customElements.get("foundation-video")) {
  class FoundationVideo extends HTMLElement {
    constructor() {
      super();

      this.poster = this.querySelector('[id^="Deferred-Poster-"]');

      if (!this.poster) return;

      this.videoId = this.poster.dataset.videoId;

      if (!this.videoId) return;

      this.poster.addEventListener("click", this.loadContent.bind(this));
    }

    loadContent(focus = true) {
      window.pauseAllMedia();

      const modal = document.getElementById(this.videoId);
      if (!modal) return;

      const modalContent = modal.querySelector(".custom-video-content");
      const template = this.querySelector("template");

      if (!template || !modalContent) return;

      const content = template.content.firstElementChild.cloneNode(true);

      const mediaEl = content.matches("video")
        ? content
        : content.querySelector("video");

      if (!mediaEl) return;

      modalContent.querySelector("video")?.remove();
      modalContent.appendChild(mediaEl);

      modal.removeAttribute("hidden");

      const closeModal = () => {
        if (mediaEl.tagName === "VIDEO") {
          mediaEl.pause();
        }
        modal.setAttribute("hidden", "");
      };

      modal
        .querySelector(".custom-video-overlay")
        ?.addEventListener("click", closeModal);
      modal
        .querySelector(".custom-video-close")
        ?.addEventListener("click", closeModal);

      document.addEventListener(
        "keydown",
        (e) => {
          if (e.key === "Escape") closeModal();
        },
        { once: true },
      );

      if (focus && typeof mediaEl.focus === "function") {
        mediaEl.focus();
      }

      if (mediaEl.tagName === "VIDEO" && mediaEl.hasAttribute("autoplay")) {
        mediaEl.play().catch((error) => {
          console.error("Failed to play video:", error);
        });
      }

      const originalStyle = mediaEl.getAttribute("style");
      mediaEl.setAttribute("style", "display: block;");

      setTimeout(() => {
        if (originalStyle !== null) {
          mediaEl.setAttribute("style", originalStyle);
        } else {
          mediaEl.removeAttribute("style");
        }
      }, 0);
    }
  }

  customElements.define("foundation-video", FoundationVideo);
}
